module.exports = __webpack_public_path__ + "static/img/v11.860e7c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v11.svg
// module id = PF3Y
// module chunks = 0